import * as React from "react"
const InfoIcon = ({fill}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="-14.652 -10.327 527.75 560.069"
  >
    <path
      d="m335.901 414.718 92.142-41.483 54.42 48.139-13.98 95.512h-46.318l-97.833-62.288z"
      style={{
        fill: "#fff",
        stroke: "transparent",
      }}
    />
    <rect
      width={432.653}
      height={435.064}
      x={34.775}
      y={24.809}
      rx={19}
      ry={19}
      style={{
        fill: "#fff",
        stroke: "#fff",
      }}
    />
    <path fill={fill} d="M245.347 174.987a27.356 27.356 0 0 1-19.336-8.008 27.346 27.346 0 0 1-8.008-19.336v-12.848a27.34 27.34 0 0 1 13.672-23.68 27.332 27.332 0 0 1 27.344 0 27.338 27.338 0 0 1 13.672 23.68v12.848c0 7.25-2.88 14.207-8.008 19.336a27.354 27.354 0 0 1-19.336 8.008ZM245.347 369.55a27.34 27.34 0 0 1-27.344-27.344v-110.65a27.34 27.34 0 0 1 13.672-23.68 27.351 27.351 0 0 1 27.344 0 27.338 27.338 0 0 1 13.672 23.68v110.65a27.34 27.34 0 0 1-27.344 27.344Z" />
    <path fill={fill} d="M449.087 549.74a63.538 63.538 0 0 1-33.47-9.633l-78.18-48.25h-225.09a127.147 127.147 0 0 1-127-127.004v-248.18a127.166 127.166 0 0 1 37.239-89.762 127.16 127.16 0 0 1 89.762-37.238h273.75a127.166 127.166 0 0 1 89.762 37.238 127.16 127.16 0 0 1 37.238 89.762V388.67c0 9.77-5.211 18.797-13.672 23.68a27.332 27.332 0 0 1-27.344 0 27.338 27.338 0 0 1-13.672-23.68V116.673a72.417 72.417 0 0 0-21.203-51.109 72.412 72.412 0 0 0-51.11-21.203h-273.75A72.417 72.417 0 0 0 61.24 65.564a72.412 72.412 0 0 0-21.203 51.11v248.18a72.41 72.41 0 0 0 21.203 51.112 72.412 72.412 0 0 0 51.109 21.203h232.84a27.33 27.33 0 0 1 14.359 4.074l84.78 52.324h.005a9.103 9.103 0 0 0 9.23.204 9.112 9.112 0 0 0 4.68-7.96l-.012-112.09c0-9.77 5.21-18.798 13.672-23.68a27.332 27.332 0 0 1 27.344 0 27.337 27.337 0 0 1 13.672 23.68l.012 112.1v-.005a63.071 63.071 0 0 1-8.68 32.375 63.076 63.076 0 0 1-24.043 23.348 63.758 63.758 0 0 1-31.125 8.203l.005-.002Z" />
  </svg>
)
export default InfoIcon;
